import React from "react";
import PhotoUploader from "@/components/visit/PhotoUploader";
import { MIN_PROPERTY_PHOTOS, PHOTO_TAGS } from "@/lib/visitSchema";

export default function PropertyPhotosStep({ form, uploads }) {
  const photos = form.property_photos;
  const pct = Math.min(100, Math.round((photos.length / MIN_PROPERTY_PHOTOS) * 100));
  const counts = PHOTO_TAGS.map((t) => ({ ...t, n: photos.filter((p) => p.tag === t.value).length }));
  return (
    <div className="space-y-4" data-testid="visit-step-photos-panel">
      <div>
        <div className="flex items-center justify-between text-xs mb-1">
          <span className="text-slate-600">Minimum {MIN_PROPERTY_PHOTOS} property photos</span>
          <span className={`font-semibold ${photos.length >= MIN_PROPERTY_PHOTOS ? "text-emerald-700" : "text-slate-700"}`} data-testid="visit-photo-progress">{photos.length} / {MIN_PROPERTY_PHOTOS}</span>
        </div>
        <div className="h-2 rounded-full bg-slate-100 overflow-hidden"><div className={`h-full transition-[width] duration-300 ${pct >= 100 ? "bg-emerald-500" : "bg-slate-950"}`} style={{ width: `${pct}%` }} /></div>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {counts.map((c) => (
          <span key={c.value} className={`text-[11px] px-2 py-0.5 rounded-full border ${c.n ? "bg-emerald-50 border-emerald-200 text-emerald-800" : "bg-white border-slate-200 text-slate-500"}`} data-testid={`visit-tag-count-${c.value}`}>{c.label} · {c.n}</span>
        ))}
      </div>
      <PhotoUploader section="property" label="Property photos" showTags min={MIN_PROPERTY_PHOTOS} files={photos} uploads={uploads}
        hint="Pick a tag, then take or choose photos — cover front, road, all boundaries, interior, roof and surroundings." testId="visit-upload-property" />
    </div>
  );
}
